import { FC } from "react";
import { getAvatarUrl, useGetUserDataQuery } from "entities/user";
import UserIcon from "assets/svg/user.svg";

import styles from "./ProfileButton.module.css";

interface Props {
  className?: string;
  onClick: () => void;
}

export const ProfileButton: FC<Props> = ({ className, onClick }) => {
  const { data } = useGetUserDataQuery();
  const avatarUrl = data ? getAvatarUrl(data.avatar) : null;

  return (
    <button className={className} title="Profile" onClick={onClick}>
      {avatarUrl ? (
        <img src={avatarUrl} alt="User Avatar" className={styles.avatar} />
      ) : (
        <svg className="icon" width="24" height="24">
          <use href={UserIcon} />
        </svg>
      )}
    </button>
  );
};
